import { Observable, combineLatest, map } from 'rxjs';
import { components$ } from 'streams/components/components$';
import { references$ } from 'streams/references/references$';
import { persistentWorkspaces$ } from 'streams/workspaces/workspaces$';
import { orgUsersById$ } from 'streams/orgUsers/orgUsers$';
import type { QueryBuilderLabelSources } from './types';

/**
 * The loaded records the query builder labels ids from. Records that aren't
 * loaded fall back to an API fetch in the label loaders.
 */
export const queryBuilderLabelSources$: Observable<QueryBuilderLabelSources> =
  combineLatest({
    orgUsersById: orgUsersById$,
    components: components$,
    references: references$,
    workspaces: persistentWorkspaces$,
  }).pipe(
    map(({ orgUsersById, components, references, workspaces }) => ({
      orgUsersById,
      componentsById: components.byId,
      referencesById: references.byId,
      workspacesById: workspaces.byId,
    }))
  );
